<div *ngIf="report">
  <div [style]="styles.header.page">
    <div [style]="styles.header.text">
      <b>{{ improvementHeader }}</b>
    </div>
    <div [style]="styles.header.line"></div>
  </div>

  <div [style]="styles.container_padding">
    <h2 [style]="styles.general_h2">
      <b>{{ improvementHeading }}</b>
    </h2>

    <p [style]="styles.paragraph">
      {{ summaryLine }}
      <span [style]="styles.highlight">{{ report.leastDevCoachingStyle || '...' }}</span>.
    </p>

    <p [style]="styles.paragraph" [innerHTML]="html"></p>
  </div>
</div>